const DUMMY_GAP = ['gap-10', 'gap-20', 'gap-30', 'gap-40', 'gap-50', 'gap-60', 'gap-70', 'gap-80', 'gap-90', 'gap-100'].map((item, index) => <option key={index} value={item}>{item}</option>)

const Flex = props => {
    return <div className="container fluid py-2" id="flex">

        <div className="container fluid">
            <p className="text xl"><a href="#flex" className="link">&#128279;</a> Flex</p>
            <p className="text md">
                As the title states this category of classes apply flex properties to multiple children
                elements in a parent element, I chose to named them accordingly so when used the developer
            know what that class is doing, all these classes have property <code>display: flex</code> included.</p>
        </div>

        <div className="spacer md"></div>

        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true" table-hover="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark align-items-center')}>
                            <td>
                                <code>.align-items-center</code>
                            </td>
                            <td>Align the items to center</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark align-items-end')}>
                            <td>
                                <code>.align-items-end</code>
                            </td>
                            <td>Align the items to end</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark align-items-start')}>
                            <td>
                                <code>.align-items-start</code>
                            </td>
                            <td>Align the items to start</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark justify-content-center')}>
                            <td>
                                <code>.justify-content-center</code>
                            </td>
                            <td>Justifies the items to center</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark justify-content-end')}>
                            <td>
                                <code>.justify-content-end</code>
                            </td>
                            <td>Justifies the items to end</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark justify-content-start')}>
                            <td>
                                <code>.justify-content-start</code>
                            </td>
                            <td>Justifies the items to start</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark space-between')}>
                            <td>
                                <code>.space-between</code>
                            </td>
                            <td>Pushes space between items</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark space-around')}>
                            <td>
                                <code>.space-around</code>
                            </td>
                            <td>Pushes space around items</td>
                        </tr>
                        <tr
                            onClick={() => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', 'h25 border-dark space-evenly')}>
                            <td>
                                <code>.space-evenly</code>
                            </td>
                            <td>Pushes space evenly around items</td>
                        </tr>
                        <tr>
                            <td>
                                <code>.gap-10, .gap-20, .gap-30, .gap-40, .gap-50, .gap-60, .gap-70, .gap-80, .gap-90, .gap-100</code>
                            </td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the gap between items</label>
                                    <select onChange={(e) => props.helper(['flex-display-column', 'flex-display-row'], 'flex-property', `min-h25 border-dark`, e)}>
                                        {DUMMY_GAP}
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container sm my-2 p-1 border-dark">
            <p className="text xxs">.row</p>
            <div id="flex-display-row" className="row h25 border-dark">
                <div className="border-light h-25 bg-primary" style={{ height: '40px', width: '40px' }}></div>
                <div className="border-light h-25 bg-primary" style={{ height: '40px', width: '40px' }}></div>
                <div className="border-light h-25 bg-primary" style={{ height: '40px', width: '40px' }}></div>
            </div>
            <p className="text xxs">.column</p>
            <div id="flex-display-column" className="column h25 border-dark">
                <div className="border-light h-25 bg-primary" style={{ height: '40px', width: '40px' }}></div>
                <div className="border-light h-25 bg-primary" style={{ height: '40px', width: '40px' }}></div>
                <div className="border-light h-25 bg-primary" style={{ height: '40px', width: '40px' }}></div>
            </div>
        </div>


    </div>
}

export default Flex